module.exports = __webpack_public_path__ + "img/img14.d12aab75.svg";